import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import * as amplitude from '@amplitude/analytics-browser';

amplitude.init('b360614a37ca61cf58ebf731ec810785', {"autocapture":true});

Sentry.init({
  dsn: "https://d6f9b6ca4ecf9319bf19667151a89fa1@o4509229605781504.ingest.de.sentry.io/4509229609058384",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration()
  ],
  tracesSampleRate: 0.5, // Capture 100% of the transactions (can lower later)
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/makerspace3d\.co\.za\/.*/,
    /^https:\/\/www\.makerspace3d\.co\.za\/.*/,
    "https://makerspace3d\.co\.za",
    "https://www.makerspace3d\.co\.za"
  ],
  profilesSampleRate: 0.5, // Capture 100% of profiles
  sendDefaultPii: true,
  environment: 'testingg'
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
